import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import About from './About';
import Features from './Features';
import Tools from './Tools';
import Projects from './Projects';
import Docs from './Docs';
import Whitepaper from './Whitepaper';
import Blog from './Blog';
import BlogArticle1 from './BlogArticle1';
import BlogArticle2 from './BlogArticle2';
import BlogArticle3 from './BlogArticle3';
import ApiKeysHelp from './ApiKeysHelp';
import Unauthorized from './Unauthorized';
import ServerUnavailable from './ServerUnavailable';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/about" element={<About />} />
      <Route path="/features" element={<Features />} />
      <Route path="/tools" element={<Tools />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/docs" element={<Docs />} />
      <Route path="/whitepaper" element={<Whitepaper />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/function-calling" element={<BlogArticle1 />} />
      <Route path="/blog/hierarchical-agents" element={<BlogArticle2 />} />
      <Route path="/blog/percolation-emergent-capability" element={<BlogArticle3 />} />
      <Route path="/help-getting-api-keys" element={<ApiKeysHelp />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/server-unavailable" element={<ServerUnavailable />} />
    </Routes>
  </Router>
);
